import {useCallback, useEffect, useRef} from "react"
import {useDispatch, useSelector} from "react-redux"
import {changeLanguageSelectors, changeLanguageSlice} from "../../slices/changeLanguageSlice"
import {authAPI} from "../../api/authAPI"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"

export const useChangeLanguageAPI = () => {
    const dispatch = useDispatch()
    const status = useSelector(changeLanguageSelectors.getStatus)
    const statusRef = useRef(status)
    statusRef.current = status

    const fetch = useCallback(() => {
        if (statusRef.current === APIStatus.Initial) {
            dispatch(changeLanguageSlice.actions.startFetch())
            dispatch(
                authAPI.getAvailableLocales({
                    onSuccess: (response) => {
                        dispatch(changeLanguageSlice.actions.successFetch(response))
                    },
                    onError: () => {
                        dispatch(changeLanguageSlice.actions.failFetch())
                    },
                })
            )
        }
    }, [dispatch])

    useEffect(() => {
        fetch()
    }, [dispatch, fetch])
}
